export var ConsultationMode;
(function (ConsultationMode) {
    ConsultationMode["ONLINE"] = "ONLINE";
    ConsultationMode["OFFLINE"] = "OFFLINE";
})(ConsultationMode || (ConsultationMode = {}));
